// extracted by mini-css-extract-plugin
export var growableInput = "_73-0";
export var tagContainer = "_73-2";
export var textInput = "_73-1";